import React, { Fragment } from 'react'
import { Can } from '@app/context/ability-context'

import SVG from 'react-inlinesvg'
import downloadIcon from '@icons/download/default'

const CertificateButton = ({ student, className, children }) => {
  if (!student.isParticipated) { return null }

  return (
    <Can I="read" of="Diplomas">
      <a href={student.participation.download}
         target="_blank"
         className={className}>

        { children ? children : (
            <Fragment>
              <SVG src={downloadIcon} />
              { I18n.t('awards.download') }
            </Fragment>
          )
        }
      </a>
    </Can>
  )
}

export default CertificateButton
